import { ComponentCategory, ComponentOption } from "@/types/types";

const baseStorage: Omit<ComponentOption, 'socketType' | 'modelPath' | 'scale'>[] = [
  {
    id: "storage-1",
    name: "Samsung 980 Pro",
    brand: "Samsung",
    price: 99.99,
    amazonLink: "#",
    specs: {
      capacity: "1TB",
      type: "NVMe SSD",
      interface: "PCIe 4.0",
      readSpeed: "7000 MB/s",
      writeSpeed: "5000 MB/s"
    },
    imageUrl: "",
    variants: [
      {
        id: "storage-1",
        name: "Samsung 980 Pro 1TB",
        price: 99.99,
        specs: { capacity: "1TB" }
      },
      {
        id: "storage-2",
        name: "Samsung 980 Pro 2TB",
        price: 189.99,
        specs: { capacity: "2TB" }
      }
    ]
  },
  {
    id: "storage-crucial-p3-plus",
    name: "Crucial P3 Plus",
    brand: "Crucial",
    price: 54.99,
    amazonLink: "#",
    specs: {
      capacity: "1TB",
      type: "NVMe SSD",
      interface: "PCIe 4.0",
      readSpeed: "5000 MB/s",
      writeSpeed: "3600 MB/s"
    },
    imageUrl: "",
    variants: [
      {
        id: "storage-3",
        name: "Crucial P3 Plus 1TB",
        price: 54.99,
        specs: { capacity: "1TB" }
      },
      {
        id: "storage-4",
        name: "Crucial P3 Plus 2TB",
        price: 104.99,
        specs: { capacity: "2TB" }
      }
    ]
  },
  {
    id: "storage-wd-black-sn850x",
    name: "WD Black SN850X",
    brand: "Western Digital",
    price: 84.99,
    amazonLink: "#",
    specs: {
      capacity: "1TB",
      type: "NVMe SSD",
      interface: "PCIe 4.0",
      readSpeed: "7300 MB/s",
      writeSpeed: "6300 MB/s"
    },
    imageUrl: "",
    variants: [
      {
        id: "storage-5",
        name: "WD Black SN850X 1TB",
        price: 84.99,
        specs: { capacity: "1TB" }
      },
      {
        id: "storage-6",
        name: "WD Black SN850X 2TB",
        price: 159.99,
        specs: { capacity: "2TB" }
      }
    ]
  },
  {
    id: "storage-silicon-power-nvme",
    name: "Silicon Power NVMe SSD",
    brand: "Silicon Power",
    price: 60,
    amazonLink: "https://amzn.to/3GklgP5",
    specs: {
      capacity: "1TB",
      type: "NVMe SSD",
      interface: "PCIe 4.0",
      readSpeed: "3500 MB/s",
      writeSpeed: "2900 MB/s"
    },
    imageUrl: "",
    variants: [
      {
        id: "storage-9",
        name: "Silicon Power 1TB",
        price: 60,
        specs: { capacity: "1TB", readSpeed: "3500 MB/s", writeSpeed: "2900 MB/s" }
      },
      {
        id: "storage-10",
        name: "Silicon Power 2TB",
        price: 100,
        specs: { capacity: "2TB", readSpeed: "3500 MB/s", writeSpeed: "2900 MB/s" }
      },
      {
        id: "storage-11",
        name: "Silicon Power 4TB",
        price: 220,
        specs: { capacity: "4TB", readSpeed: "5000 MB/s", writeSpeed: "4500 MB/s" }
      }
    ]
  },
  {
    id: "storage-wd-blue-hdd",
    name: "WD Blue HDD",
    brand: "Western Digital",
    price: 50,
    amazonLink: "https://amzn.to/3GklgP5",
    specs: {
      capacity: "1TB",
      type: "HDD",
      interface: "SATA",
      readSpeed: "220 MB/s",
      writeSpeed: "210 MB/s"
    },
    imageUrl: "",
    variants: [
      {
        id: "storage-12",
        name: "WD Blue 1TB HDD",
        price: 50,
        specs: { capacity: "1TB" }
      },
      {
        id: "storage-13",
        name: "WD Blue 2TB HDD",
        price: 85,
        specs: { capacity: "2TB" }
      },
      {
        id: "storage-14",
        name: "WD Blue 4TB HDD",
        price: 95,
        specs: { capacity: "4TB" }
      },
      {
        id: "storage-15",
        name: "WD Blue 8TB HDD",
        price: 150,
        specs: { capacity: "8TB" }
      }
    ]
  },
  {
    id: "storage-8",
    name: "NO DRIVE",
    brand: "NONE",
    price: 0,
    amazonLink: "#",
    specs: {},
    imageUrl: ""
  }
];

const storageOptions: ComponentOption[] = baseStorage.flatMap(storage => {
  if (storage.id === 'storage-8') { // "NO DRIVE"
    return storage as ComponentOption;
  }

  let socketType = 'M2_SOCKET'; // Default for NVMe
  let modelPath = '/models/m2_ssd.glb';
  let scale: [number, number, number] = [0.1, 0.1, 0.1];

  // Assign socket and model based on drive type
  switch (storage.specs.type) {
    case 'SATA SSD': // 2.5-inch
      socketType = 'STORAGE_2.5IN';
      modelPath = '/models/ssd_2.5in.glb'; // Placeholder path
      scale = [1, 1, 1]; // Placeholder scale
      break;
    case 'SATA HDD': // 3.5-inch
      socketType = 'STORAGE_3.5IN';
      modelPath = '/models/hdd_3.5in.glb'; // Placeholder path
      scale = [1, 1, 1]; // Placeholder scale
      break;
  }

  return {
    ...storage,
    socketType,
    modelPath,
    scale,
  };
});

export const storageComponents: ComponentCategory = {
  id: "storage",
  name: "Storage",
  description: "Long-term data storage for your operating system, programs, and files.",
  required: true,
  options: storageOptions,
};
